import {Component, ElementRef, OnDestroy} from '@angular/core';
import {LoanApplicationService} from '../loan-application.service';
import {LoanApplication} from '../../../@models/loan-application.model';
import {WebsiteStatesService} from '../../../website-states.service';
import {BreakpointConfig} from '../../../website-states.enum';

@Component({
  selector: 'bb-loan-request',
  templateUrl: './loan-request.component.html',
  styleUrls: ['./loan-request.component.scss'],
})
export class LoanRequestComponent implements OnDestroy {
  employment_type = LoanApplication.EmploymentType;
  isGetLoan = this.loan.routePrefix.map(p => p === 'get-loan' || p === 'cebu' || p === 'seaman');

  employmentType = this.loan.form.get('employment_info.employment_type');
  targetLoanAmount = this.loan.form.get('slider_config.target_loan_amount');
  targetLoanDuration = this.loan.form.get('slider_config.target_loan_duration');
  apr = this.employmentType.valueChanges
    .startWith(this.employmentType.value)
    .map(value => {
      if (value === this.employment_type.sea) {
        return '92%';
      } else {
        return '69%';
      }
    });
  seaLoanDuration = '3 to 8 months';
  landLoanDuration = '6 to 12 months';
  loanDuration = this.landLoanDuration ? this.employmentType.value === LoanApplication.EmploymentType.land : this.seaLoanDuration;

  asideWidthSub = this.website.viewport
    .map((config: BreakpointConfig) => {
      if (config.gteXSmall) {
        return '';
      }
      if (config.gteSmall) {
        return '250px';
      }
      return '360px';
    })
    .subscribe(width => this.$el.nativeElement.style.setProperty('--aside-width', width));

  constructor(public loan: LoanApplicationService,
              private website: WebsiteStatesService,
              private $el: ElementRef<HTMLElement>) {

    if (this.employmentType.value === LoanApplication.EmploymentType.land) {
      this.loanDuration = this.landLoanDuration;
    } else {
      this.loanDuration = this.seaLoanDuration;
    }

    this.employmentType.valueChanges.subscribe(
      value => {
        if (value === LoanApplication.EmploymentType.sea) {
          this.loanDuration = this.seaLoanDuration;
        } else {
          this.loanDuration = this.landLoanDuration;
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.asideWidthSub.unsubscribe();
  }

  forward() {
    this.loan.forward();
  }
}
